import { Component, OnInit, OnDestroy, ViewChild, ElementRef, NgZone, AfterViewInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { FormControl } from '@angular/forms';
import { faBicycle, faWalking, faSubway, faCar } from '@fortawesome/free-solid-svg-icons';
import { ReseauService } from '@/service/reseau.service';
import { Poly } from '@/dto/polygon/poly';
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import { Loader, LoaderOptions } from '@googlemaps/js-api-loader';
import { ActivatedRoute, Router } from '@angular/router';


const GOOGLE_MAPS_API_KEY: string = window.env.googleMapsAPIKey;

const mapLoaderOptions: LoaderOptions = {
    apiKey: GOOGLE_MAPS_API_KEY,
    version: 'weekly',
    libraries: ['places', 'drawing', 'visualization', 'geometry'],
    region: "fr",
}
const renderer = {
    render({ count, position }) {
        return new google.maps.Marker({
            label: { text: String(count), color: "white", fontSize: "12px" },
            position,
            icon: "assets/img/m1.png",
            // adjust zIndex to be above other markers
            zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
        })
    }
}
@Component({
    selector: 'app-reseau',
    templateUrl: './reseau.page.html',
    styleUrls: ['./reseau.page.scss']
})
export class ReseauPage implements OnInit, OnDestroy, AfterViewInit {
    private unsubscribe: Subscription[] = [];
    objectKeys = Object.keys;
    public map: any;
    public directionsService: any;
    public directionsRenderer: any;
    public selectedMode: any;
    public request: any;
    public startPoint: any;
    public endPoint: any;
    public autocomplete: any;
    private markers = [];
    private lonlatset = false;
    private lat = 0;
    private lon = 0;
    public listPos: any = [];
    public zoom: number;
    public upperRightCorner: number[];
    public downLeftCorner: number[]
    public faBicycle: any;
    public faWalking: any;
    public faSubway: any;
    public faCar: any;
    //private poly: Poly;
    public latitude: string;
    public longitude: string;
    private poly: Poly;
    private markerCluster: MarkerClusterer;
    public address: string;
    public showRouteDetails: boolean;

    private mapOptions = {
        center: {

            lat: 48.806373,
            lng: 2.353016

        },
        zoom: 12
    }

    @ViewChild("search", { static: false }) public searchElementRef: ElementRef;
    public searchControl: FormControl;
    constructor(private ngZone: NgZone,
        private reseauService: ReseauService, private router: ActivatedRoute, public route: Router) {
        this.faBicycle = faBicycle;
        this.faWalking = faWalking;
        this.faSubway = faSubway;
        this.faCar = faCar;
        this.showRouteDetails = false;
    }


    ngAfterViewInit(): void {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position: GeolocationPosition) => {
                this.mapOptions.center.lat = position.coords.latitude;
                this.mapOptions.center.lng = position.coords.longitude;
                this.initializeMap();
            }, (error: GeolocationPositionError) => {
                this.initializeMap();
            });
        } else {
            this.initializeMap();
        }
    }

    initializeMap() {
        this.searchControl = new FormControl();
        const mapLoader = new Loader(mapLoaderOptions);
        mapLoader
            .load()
            .then((google) => {
                this.directionsService = new google.maps.DirectionsService();
                this.directionsRenderer = new google.maps.DirectionsRenderer();
                this.map = new google.maps.Map(document.getElementById("map"), this.mapOptions);

                // this.setPositiongoogle();
                this.router.queryParams.subscribe(params => {

                    let service = new google.maps.places.PlacesService(this.map);
                    var request = {
                        query: params["address"]
                    };
                    service.textSearch(request, (results, status) => {
                        if (status == google.maps.places.PlacesServiceStatus.OK && results.length > 0) {
                            this.searchElementRef.nativeElement["value"] = params["address"];
                            this.map.setCenter(new google.maps.LatLng(results[0].geometry.location.lat(), results[0].geometry.location.lng()));
                        }
                    })
                });
                this.map.addListener('bounds_changed', () => {
                    if (this.map.getBounds()) {
                        this.poly = new Poly();
                        this.poly.upperRightCorner = [this.map.getBounds().getNorthEast().lng(), this.map.getBounds().getNorthEast().lat()];
                        this.poly.downLeftCorner = [this.map.getBounds().getSouthWest().lng(), this.map.getBounds().getSouthWest().lat()];
                        this.zoom = this.map.getZoom();
                        if (this.listPos.length === 0) {
                            this.poly.center = [this.map.center.lng(), this.map.center.lat()];

                            this.updateData();
                        }
                    }
                })
                this.autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
                    fields: ["address_component", "adr_address", "formatted_address", "geometry", "icon", "name", "business_status", "photo", "type", "url", "utc_offset_minutes", "vicinity"],
                });
                this.autocomplete.addListener("place_changed", () => {
                    this.ngZone.run(() => {
                        this.hideRoute();

                        ////get the place result
                        const place: google.maps.places.PlaceResult = this.autocomplete.getPlace();
                        ////verify result
                        if (!place.geometry) {
                            return;
                        }

                        ////set latitude, longitude and zoom
                        this.map.setCenter({ lat: place.geometry.location.lat(), lng: place.geometry.location.lng() });


                        this.clearMarker();

                        this.map.setZoom(12);

                        this.poly.center = [place.geometry.location.lng(), place.geometry.location.lat()];

                        this.updateData();


                    });
                });
            }).catch(e => {
                console.log(e);
            });;
    }


    ngOnInit() {

    }

    updateData() {
        this.unsubscribe.push(this.reseauService.getInsidePoly(this.poly).subscribe(val => {
            this.listPos = val;
            const total = val.length;
            for (let i = 0; i < total; i++) {
                const marker = new google.maps.Marker({
                    position: new google.maps.LatLng(val[i]['latitude'], val[i]['longitude']),
                    map: this.map,
                    title: val[i]["storename"],
                    icon: 'assets/img/bulle-geoloc.png'
                });
                const item = val[i];
                marker["longitude"] = val[i]["longitude"];
                marker["latitude"] = val[i]["latitude"];
                marker.addListener("click", () => {
                    this.hideRoute();
                    this.markers.forEach(c => {
                        c.setAnimation(null);
                        this.listPos.splice(this.listPos.indexOf(item), 1)
                        this.listPos.unshift(item)
                    });
                    if (marker.getAnimation()) {
                        marker.setAnimation(null);
                    } else {
                        marker.setAnimation(google.maps.Animation.BOUNCE);
                        this.latitude = marker["latitude"];
                        this.longitude = marker["longitude"];
                    }
                });
                this.markers.push(marker);

            }

            this.markerCluster = new MarkerClusterer({
                map: this.map,
                markers: this.markers,
                renderer: renderer
            });

        }));
    }

    clickPos(item) {
        // this.hideRoute();
        // this.map.setCenter(new google.maps.LatLng(item.latitude, item.longitude));
        // this.markers.forEach(c => {
        //     if (c["longitude"] === item["longitude"] && c["latitude"] === item["latitude"]) {
        //         this.longitude = c["longitude"];
        //         this.latitude = c["latitude"];
        //         c.setAnimation(google.maps.Animation.BOUNCE);

        //         this.listPos.splice(this.listPos.indexOf(item), 1)
        //         this.listPos.unshift(item)
        //     }
        //     else
        //         c.setAnimation(null);
        // });

    }


    setPositiongoogle() {
        if (this.map && this.lonlatset === false && this.lat !== 0 && this.lon !== 0) {
            this.lonlatset = true;
            this.map.setCenter(new google.maps.LatLng(this.lat, this.lon));
            const marker = new google.maps.Marker({
                position: new google.maps.LatLng(this.lat, this.lon),
                map: this.map,
                title: ''
            });
            this.markers.push(marker);
        }
    }

    clearMarker() {
        this.markers.forEach(c => {
            c.setMap(null);
        });
        this.markers = [];
        this.markerCluster.clearMarkers();
    }

    calcRoute(item, mode) {
        this.selectedMode = mode;
        this.endPoint = new google.maps.LatLng(item.latitude, item.longitude);
        this.directionsRenderer.setMap(this.map);
        this.directionsRenderer.setPanel(document.getElementById('sidepanel'));
        if (this.autocomplete.getPlace() != undefined) {
            this.startPoint = new google.maps.LatLng(this.autocomplete.getPlace().geometry.location.lat(), this.autocomplete.getPlace().geometry.location.lng());
        }
        else {
            this.startPoint = new google.maps.LatLng(this.mapOptions.center.lat, this.mapOptions.center.lng);
        }

        this.request = {
            origin: this.startPoint,
            destination: this.endPoint,
            travelMode: google.maps.TravelMode[mode]
        };

        this.showRouteDetails = true;
        this.directionsService.route(this.request, (response, status) => {
            if (status == 'OK') {
                this.directionsRenderer.setDirections(response);
            }
        });

    }

    hideRoute() {
        this.showRouteDetails = false;
        this.directionsRenderer.setMap(null);
        this.directionsRenderer.setPanel(null);
    }

    ngOnDestroy() {
        this.unsubscribe.forEach(s => s.unsubscribe());
        this.clearMarker();
    }
}
